import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const TableStack = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: "5px",
}));
